import { Component } from '@angular/core';

@Component({
    selector: 'app-refresh',
    templateUrl: './refresh.component.html',
    styleUrls: ['./refresh.component.css'],
    standalone: false
})
export class RefreshComponent {

}
